import { useQuery } from '@tanstack/react-query';
import type { UseQueryOptions } from '@tanstack/react-query';
import type { UserModifiedProductFilter, UserModifiedProductItem } from 'v2/interfaces/productChangeHistory';
import productChangeHistoryService from 'v2/services/ProductChangeHistory';

type Payload = {
  productId: number;
  filter: UserModifiedProductFilter;
};

export function useUsersModifiedProduct(
  { productId, filter }: Payload,
  options: Omit<UseQueryOptions<UserModifiedProductItem[]>, 'queryKey' | 'queryFn'> = {}
) {
  return useQuery({
    queryKey: ['product', productId, 'changeHistory', 'users', filter],
    queryFn: () => productChangeHistoryService.getUsersChangeHistory(productId, filter),
    ...options
  });
}
